module.exports = __webpack_public_path__ + "img/mobile_1.4650d48e.png";